module.exports = __webpack_public_path__ + "static/media/MAIN-SLIDER-Buy.2b66d96b.png";